var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "virtual-tour-modal"
  }, [_c('div', {
    staticClass: "virtual-tour-modal__mask"
  }), _c('div', {
    staticClass: "virtual-tour-modal__inner"
  }, [_c('iframe', {
    staticClass: "touch",
    attrs: {
      "id": "virtual-tour",
      "src": _vm.isMatterport ? _vm.url + _vm.matterportParams : _vm.url,
      "frameborder": "0"
    }
  }), _vm.isMatterport ? [_c('div', {
    staticClass: "iframe-mask iframe-mask--left"
  }), _c('div', {
    staticClass: "iframe-mask iframe-mask--right"
  })] : _vm._e(), _c('div', {
    staticClass: "iframe-close touch",
    on: {
      "click": _vm.close
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fas', 'times']
    }
  })], 1)], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }